import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate, { veeCfg } from './validator'
import router from './router'
import App from './App'
import store from './store'
import i18n from './i18n'
import directives from './directives'
import session from '@/auth/session'
import sso from '@/auth/sso'
import filters from '@/filters/filters'
import config from '@/utils/config'
import cipher from '@/utils/cipher'
import _ from 'lodash'

import { promotersConfig } from 'profiles/eurobits/selectors/SupportConfiguration'
import '@/styles/style.scss'

import VueAnalytics from 'vue-analytics'
import VueYouTube from 'vue-youtube'

/* Add IE support */
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

/**
 * Configuración VueAnalytics. Análisis de la actividad en PRE (pruebas) y en PRO.
 */
Vue.use(VueAnalytics, {
  id: config.googleAnalyticsId,
  router,
  ignoreRoutes: ['/alta/nueva-factura'],
  debug: {
    enabled: false, // default value: false
    trace: false, // default value: false
    sendHitTask: config.NODE_ENV !== 'development' // No envía a GA en modo develop
  }
})

/**
 * Plugins: BootstrapVue, VueValidate, VueYouTube
 */
Vue.use(BootstrapVue)
Vue.use(VeeValidate, veeCfg(i18n))
Vue.use(VueYouTube)
// Vue.config.productionTip = false

/* Register all directives */
Object.keys(directives).forEach(k => Vue.directive(k, directives[k]))

/* Register all filters */
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

Vue.set(Vue.prototype, '_', _)

/**
 * Función de iniciación de la Aplicación.
 * Si no es una sesión de soporte elimina los datos de sesión.
 * @return {object} - Configuración de Vue
 */
function initializeApp() {
  if (!session.isSupportSession()) {
    session.destroy()
  }
  return new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {
      App
    },
    template: '<App/>'
  })
}

if (window.addEventListener) {
  window.addEventListener('message', saveSessionData, false)
} else {
  window.attachEvent('onmessage', saveSessionData)
}

/**
 * método que permite enviar la información de sesión al iframe en otro dominio
 * Si es eurobits tendriamos la misma url, por tanto se puede acceder a los datos de sesión
 * @param {*} evt
 */
function saveSessionData (evt) {
  if (sso.handleMessage(evt)) {
    router.push(config.homePath)
    return
  }
  if (evt.data.support) {
    let decodedData = cipher.decrypt(evt.data.support)
    let configuration = promotersConfig.filter(item => (item.id === decodedData.app))[0]
    if (configuration.loginType === 'API_LOGIN') {
      session.saveSupport(decodedData)
    } else {
      session.save(decodedData, true)
    }
    router.push(config.homePath)
  }
}

sso.notifyReady()

initializeApp()
